import styled from 'styled-components';

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin: 0 0 24px 0;
`;

export const SpanLabelFeed = styled.span`
  font-size: 0.75em;
  font-weight: 400;
  color: red;
`;
